import React from 'react';
export interface Column<T> {
  header: string;
  accessorKey?: keyof T;
  cell?: (item: T) => React.ReactNode;
  className?: string;
}
export interface TableProps<T> {
  data: T[];
  columns: Column<T>[];
  onRowClick?: (item: T) => void;
  isLoading?: boolean;
  className?: string;
}
export function Table<T>({
  data,
  columns,
  onRowClick,
  isLoading,
  className = ''
}: TableProps<T>) {
  return <div className={`overflow-x-auto ${className}`} data-id="element-62">
      <table className="min-w-full divide-y divide-slate-200" data-id="element-63">
        <thead className="bg-slate-50" data-id="element-64">
          <tr data-id="element-65">
            {columns.map((col, idx) => <th key={idx} scope="col" className={`px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider ${col.className || ''}`} data-id="element-66">
                {col.header}
              </th>)}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-slate-200" data-id="element-67">
          {isLoading ? <tr data-id="element-68">
              <td colSpan={columns.length} className="px-6 py-4 text-center text-sm text-slate-500" data-id="element-69">
                Loading data...
              </td>
            </tr> : data.length === 0 ? <tr data-id="element-70">
              <td colSpan={columns.length} className="px-6 py-4 text-center text-sm text-slate-500" data-id="element-71">
                No data available
              </td>
            </tr> : data.map((row, rowIdx) => <tr key={rowIdx} onClick={() => onRowClick?.(row)} className={onRowClick ? 'cursor-pointer hover:bg-slate-50 transition-colors' : ''} data-id="element-72">
                {columns.map((col, colIdx) => <td key={colIdx} className="px-6 py-4 whitespace-nowrap text-sm text-slate-700" data-id="element-73">
                    {col.cell ? col.cell(row) : col.accessorKey ? String(row[col.accessorKey]) : null}
                  </td>)}
              </tr>)}
        </tbody>
      </table>
    </div>;
}